import { supabase, hasSupabaseKeys } from "./supabaseClient.js";
let _orgId = null;

function authErr(error) {
  const m = String(error?.message || error || "").toLowerCase();
  if (m.includes("invalid login")) return "البريد أو كلمة المرور غير صحيحة.";
  if (m.includes("email not confirmed")) return "لم يُؤكَّد البريد بعد - عطّل تأكيد البريد في Supabase أثناء التطوير.";
  if (m.includes("already registered") || m.includes("already been registered")) return "هذا البريد مُسجَّل مسبقًا.";
  if (m.includes("password") && m.includes("6")) return "كلمة المرور قصيرة - 6 أحرف على الأقلّ.";
  if (m.includes("rate limit")) return "محاولات كثيرة - انتظر قليلًا.";
  return error?.message || "تعذّر إتمام العملية.";
}

export async function getSession() {
  if (!hasSupabaseKeys) return null;
  const { data } = await supabase.auth.getSession();
  return data?.session || null;
}

/* جلب المستخدم من الجلسة المحلية أولًا (يصمد أمام حجب auth/v1/user) */
async function authUserSafe() {
  for (let i = 0; i < 3; i++) {
    try { const { data } = await supabase.auth.getSession(); if (data?.session?.user) return data.session.user; } catch {}
    try { const { data: u } = await supabase.auth.getUser(); if (u?.user) return u.user; } catch {}
    if (i < 2) await new Promise((r) => setTimeout(r, 300));
  }
  return null;
}
export function onAuthChange(cb) {
  if (!hasSupabaseKeys) return () => {};
  const { data } = supabase.auth.onAuthStateChange((_e, s) => cb(s || null));
  return () => { try { data.subscription.unsubscribe(); } catch {} };
}
export async function getProfile() {
  const user = await authUserSafe();
  if (!user) return null;
  const { data, error } = await supabase.from("profiles")
    .select("id, org_id, full_name, role, organizations(name)").eq("id", user.id).maybeSingle();
  if (error) throw new Error(authErr(error));
  if (!data) return null;
  _orgId = data.org_id;
  return { id: data.id, orgId: data.org_id, fullName: data.full_name || "", role: data.role || "translator", orgName: data.organizations?.name || "", email: user.email || "" };
}
export async function signIn(email, password) {
  const { error } = await supabase.auth.signInWithPassword({ email: String(email).trim(), password });
  if (error) return authErr(error);
  return null;
}
export async function signUpManager(fullName, orgName, email, password) {
  const { data, error } = await supabase.auth.signUp({ email: String(email).trim(), password });
  if (error) return { err: authErr(error) };
  if (!data.session) return { needConfirm: true };
  const setup = await ensureOrgProfile(fullName, orgName);
  return setup.ok ? { ok: true } : { err: setup.err };
}
export async function ensureOrgProfile(fullName, orgName) {
  const au = await authUserSafe();
  if (!au) return { ok: false, err: "لا جلسة صالحة." };
  const existing = await getProfile();
  if (existing) return { ok: true };
  const { error } = await supabase.rpc("create_org_and_profile", { p_org_name: String(orgName).trim(), p_full_name: String(fullName).trim() });
  if (error) return { ok: false, err: "تعذّر إنشاء المؤسّسة/الملفّ: " + authErr(error) };
  return { ok: true };
}
export async function signOut() { _orgId = null; try { await supabase.auth.signOut(); } catch {} }
export async function getOrgId() { if (_orgId) return _orgId; const p = await getProfile(); return p?.orgId || null; }

async function adminInvoke(action, payload) {
  const { data, error } = await supabase.functions.invoke("admin-users", { body: { action, payload } });
  if (error) { let msg = error.message || "تعذّر التنفيذ"; try { const ctx = await error.context?.json?.(); if (ctx?.error) msg = ctx.error; } catch {} return { error: msg }; }
  if (data?.error) return { error: data.error };
  return { data };
}
export async function listMembers() {
  const { data, error } = await supabase.from("profiles").select("id, full_name, email, role, status, created_at").order("created_at", { ascending: true });
  if (error) throw new Error(error.message);
  return data || [];
}
export async function adminCreateUser(fullName, email, password, role) { return adminInvoke("create", { fullName, email, password, role }); }
export async function adminSetStatus(id, status) { return adminInvoke("setStatus", { id, status }); }
export async function adminSetPassword(id, password) { return adminInvoke("setPassword", { id, password }); }
export async function adminDeleteUser(id) { return adminInvoke("delete", { id }); }
export function genMemberPassword() {
  const A = "ABCDEFGHJKLMNPQRSTUVWXYZ", a = "abcdefghijkmnpqrstuvwxyz", n = "23456789";
  const all = A + a + n; let p = A[Math.floor(Math.random()*A.length)] + a[Math.floor(Math.random()*a.length)] + n[Math.floor(Math.random()*n.length)];
  for (let i = 0; i < 6; i++) p += all[Math.floor(Math.random()*all.length)];
  return p.split("").sort(() => Math.random()-0.5).join("");
}

const isUuid = (v) => typeof v === "string" && /^[0-9a-f]{8}-[0-9a-f]{4}-/i.test(v);
function bookRowToTree(b, fin, deliv, fils) {
  return { id: b.id, name: b.name || "", nameFr: b.name_fr || "", lang: b.lang || "", category: b.category || "",
    opNumber: b.op_number || "", grantNumber: b.grant_number || "", grantType: b.grant_type || "", mediaPermit: b.media_permit || "",
    authorName: b.author_name || "", authorEmail: b.author_email || "", authorPhone: b.author_phone || "",
    transName: b.trans_name || "", transNat: b.trans_nat || "", transEmail: b.trans_email || "", transPhone: b.trans_phone || "",
    fee1: b.fee1 || "", fee2: b.fee2 || "", transDeliveryDate: b.trans_delivery_date || "", transReceived: !!b.trans_received,
    isbnAr: b.isbn_ar || "", isbnFr: b.isbn_fr || "", notes: b.notes || "",
    pubAr: b.pub_ar || "", pubFrHouse: b.pub_fr_house || "", pubFrName: b.pub_fr_name || "", pubFrEmail: b.pub_fr_email || "", printOffer: b.print_offer || "",
    icon: b.icon || "BookOpen", iconImg: b.icon_img || null, dotColor: b.dot_color || "rainbow",
    status: b.status || "active", visibility: b.visibility || "shared", approvalStatus: b.approval_status || "approved", finance: fin || undefined, deliveries: deliv || {}, ...(fils || {}) };
}
export function assembleTree(pubs, projs, books, fins, delivs, files) {
  const finMap = {}; (fins || []).forEach((f) => { finMap[f.book_id] = f.data; });
  const delMap = {}; (delivs || []).forEach((d) => { delMap[d.book_id] = d.data; });
  const filMap = {}; (files || []).forEach((f) => {
    const m = (filMap[f.book_id] = filMap[f.book_id] || {});
    const val = { name: f.original_name || "", type: f.mime || "", path: f.path };
    if (String(f.kind).startsWith("custom:")) {
      const parts = String(f.kind).split(":"); const cid = parts[1] || crypto.randomUUID(); const cname = parts.slice(2).join(":");
      (m.customFiles = m.customFiles || []).push({ id: cid, label: cname, file: val });
    } else m[f.kind] = val;
  });
  const booksByProj = {}; (books || []).forEach((b) => { (booksByProj[b.project_id] = booksByProj[b.project_id] || []).push(bookRowToTree(b, finMap[b.id], delMap[b.id], filMap[b.id])); });
  const projsByPub = {}; (projs || []).forEach((j) => { (projsByPub[j.publisher_id] = projsByPub[j.publisher_id] || []).push({ id: j.id, name: j.name || "", category: j.category || "", date: j.date || "", icon: j.icon || "Languages", iconImg: j.icon_img || null, dotColor: j.dot_color || "rainbow", status: j.status || "active", works: booksByProj[j.id] || [] }); });
  return (pubs || []).map((p) => ({ id: p.id, name: p.name || "", note: p.note || "", tag: p.tag || "", icon: p.icon || "Library", iconImg: p.icon_img || null, color: p.color || null, status: p.status || "active", projects: projsByPub[p.id] || [] }));
}
export function flattenTree(tree, orgId) {
  const pubRows = [], projRows = [], bookRows = [], finRows = [], delivRows = [], fileRows = [];
  const keep = { pubs: [], projs: [], books: [] };
  (tree || []).forEach((p, pi) => {
    const pid = isUuid(p.id) ? p.id : crypto.randomUUID(); p.id = pid; keep.pubs.push(pid);
    pubRows.push({ id: pid, org_id: orgId, name: p.name || "بلا اسم", note: p.note || null, tag: p.tag || null, icon: p.icon || null, icon_img: p.iconImg || null, color: p.color || null, status: p.status || "active", sort: pi });
    (p.projects || []).forEach((j, ji) => {
      const jid = isUuid(j.id) ? j.id : crypto.randomUUID(); j.id = jid; keep.projs.push(jid);
      projRows.push({ id: jid, org_id: orgId, publisher_id: pid, name: j.name || "بلا اسم", category: j.category || null, date: j.date || null, icon: j.icon || null, icon_img: j.iconImg || null, dot_color: j.dotColor || null, status: j.status || "active", sort: ji });
      (j.works || []).forEach((b, bi) => {
        const bid = isUuid(b.id) ? b.id : crypto.randomUUID(); b.id = bid; keep.books.push(bid);
        (b.customFiles || []).forEach((cf) => {
          const f = cf && cf.file; if (f && f.path) fileRows.push({ id: crypto.randomUUID(), org_id: orgId, book_id: bid, kind: "custom:" + cf.id + ":" + (cf.label || ""), original_name: f.name || "", mime: f.type || "", path: f.path });
        });
        ["coverAr","coverFr","contractAuthor","contractTrans1","contractPublisher","printOfferFile"].forEach((k) => {
          const f = b[k]; if (f && f.path) fileRows.push({ id: crypto.randomUUID(), org_id: orgId, book_id: bid, kind: k, original_name: f.name || "", mime: f.type || "", path: f.path });
        });
        bookRows.push({ id: bid, org_id: orgId, project_id: jid, name: b.name || null, name_fr: b.nameFr || null, lang: b.lang || null, category: b.category || null, op_number: b.opNumber || null, grant_number: b.grantNumber || null, grant_type: b.grantType || null, media_permit: b.mediaPermit || null, author_name: b.authorName || null, author_email: b.authorEmail || null, author_phone: b.authorPhone || null, trans_name: b.transName || null, trans_nat: b.transNat || null, trans_email: b.transEmail || null, trans_phone: b.transPhone || null, fee1: b.fee1 || null, fee2: b.fee2 || null, trans_delivery_date: b.transDeliveryDate || null, trans_received: !!b.transReceived, isbn_ar: b.isbnAr || null, isbn_fr: b.isbnFr || null, notes: b.notes || null, pub_ar: b.pubAr || null, pub_fr_house: b.pubFrHouse || null, pub_fr_name: b.pubFrName || null, pub_fr_email: b.pubFrEmail || null, print_offer: b.printOffer || null, icon: b.icon || null, icon_img: b.iconImg || null, dot_color: b.dotColor || null, status: b.status || "active", visibility: b.visibility || "shared", sort: bi });
        if (b.finance) finRows.push({ book_id: bid, org_id: orgId, data: b.finance });
        if (b.deliveries && Object.keys(b.deliveries).length) delivRows.push({ book_id: bid, org_id: orgId, data: b.deliveries });
      });
    });
  });
  return { pubRows, projRows, bookRows, finRows, delivRows, fileRows, keep };
}
export async function relTreeLoad() {
  const [pubs, projs, books, fins, delivs, files] = await Promise.all([
    supabase.from("rel_publishers").select("*").order("sort").order("created_at"),
    supabase.from("rel_projects").select("*").order("sort"),
    supabase.from("rel_books").select("*").order("sort"),
    supabase.from("rel_book_finance").select("book_id,data"),
    supabase.from("rel_book_deliveries").select("book_id,data"),
    supabase.from("rel_book_files").select("book_id,kind,original_name,mime,path"),
  ]);
  if (pubs.error) throw new Error(pubs.error.message);
  return assembleTree(pubs.data, projs.data, books.data, fins.data, delivs.data, files.data);
}
export async function relTreeSave(tree) {
  const orgId = await getOrgId(); if (!orgId) return false;
  const { pubRows, projRows, bookRows, finRows, delivRows, fileRows, keep } = flattenTree(tree, orgId);
  if (pubRows.length) { const r = await supabase.from("rel_publishers").upsert(pubRows, { onConflict: "id" }); if (r.error) throw new Error(r.error.message); }
  if (projRows.length) { const r = await supabase.from("rel_projects").upsert(projRows, { onConflict: "id" }); if (r.error) throw new Error(r.error.message); }
  if (bookRows.length) { const r = await supabase.from("rel_books").upsert(bookRows, { onConflict: "id" }); if (r.error) throw new Error(r.error.message); }
  if (finRows.length) { const r = await supabase.from("rel_book_finance").upsert(finRows, { onConflict: "book_id" }); if (r.error) throw new Error("rel_book_finance: " + r.error.message); }
  if (delivRows.length) { const r = await supabase.from("rel_book_deliveries").upsert(delivRows, { onConflict: "book_id" }); if (r.error) throw new Error("rel_book_deliveries: " + r.error.message); }
  {
    const bookIdsWithFiles = [...new Set(fileRows.map((f) => f.book_id))];
    for (const bid of bookIdsWithFiles) {
      await supabase.from("rel_book_files").delete().eq("org_id", orgId).eq("book_id", bid);
      const rows = fileRows.filter((f) => f.book_id === bid);
      if (rows.length) { const r = await supabase.from("rel_book_files").insert(rows); if (r.error) throw new Error("rel_book_files: " + r.error.message); }
    }
  }
  const inList = (arr) => "(" + (arr.length ? arr.map((x) => '"' + x + '"').join(",") : '"00000000-0000-0000-0000-000000000000"') + ")";
  const { count: dbPubs } = await supabase.from("rel_publishers").select("id", { count: "exact", head: true }).eq("org_id", orgId);
  const safeToPrune = keep.pubs.length > 0;
  if (!safeToPrune) { try { console.warn("[tpms] تقليم مُلغى - الشجرة ناقصة:", keep.pubs.length, "مقابل", dbPubs); } catch {} }
  if (safeToPrune) {
    const pruneTable = async (table, keepIds) => {
      const { data: rows } = await supabase.from(table).select("id").eq("org_id", orgId);
      if (!rows) return;
      const keepSet = new Set(keepIds);
      const extra = rows.map((r) => r.id).filter((id) => !keepSet.has(id));
      for (let i = 0; i < extra.length; i += 40) {
        const batch = extra.slice(i, i + 40);
        const r = await supabase.from(table).delete().in("id", batch);
        if (r.error) { try { console.warn("[tpms] تقليم " + table, r.error.message); } catch {} }
      }
    };
    await pruneTable("rel_books", keep.books);
    await pruneTable("rel_projects", keep.projs);
    await pruneTable("rel_publishers", keep.pubs);
  } else { try { console.warn("[tpms] شجرة فارغة - أُلغي التقليم حماية للبيانات"); } catch {} }
  return true;
}

export async function listAccess(profileId) {
  let q = supabase.from("member_access").select("id, profile_id, scope_type, scope_id, can_edit, can_view_finance, can_add_project, can_del_project, can_add_book, can_del_book, created_at");
  if (profileId) q = q.eq("profile_id", profileId);
  const { data, error } = await q;
  if (error) throw new Error(error.message);
  return data || [];
}
export async function grantAccess(profileId, scopeType, scopeId, canEdit, canViewFinance, caps) {
  const orgId = await getOrgId();
  if (!orgId) return { error: "لا مؤسّسة نشطة." };
  const c = caps || {};
  const row = { org_id: orgId, profile_id: profileId, scope_type: scopeType, scope_id: scopeType === "all" ? null : scopeId, can_edit: !!canEdit, can_view_finance: !!canViewFinance,
    can_add_project: !!c.addProject, can_del_project: !!c.delProject, can_add_book: !!c.addBook, can_del_book: !!c.delBook };
  const { data, error } = await supabase.from("member_access").insert(row).select("id").single();
  if (error) return { error: error.message };
  return { id: data.id };
}
export async function updateAccess(id, patch) {
  const { error } = await supabase.from("member_access").update(patch).eq("id", id);
  if (error) return { error: error.message };
  return { ok: true };
}
export async function revokeAccess(id) {
  const { error } = await supabase.from("member_access").delete().eq("id", id);
  if (error) return { error: error.message };
  return { ok: true };
}
export async function listScopes() {
  const [pubs, projs, books] = await Promise.all([
    supabase.from("rel_publishers").select("id, name").order("sort"),
    supabase.from("rel_projects").select("id, name, publisher_id").order("sort"),
    supabase.from("rel_books").select("id, name, project_id").order("sort"),
  ]);
  const projMap = {}; (projs.data || []).forEach((j) => { projMap[j.id] = j; });
  const enriched = (books.data || []).map((b) => ({ ...b,
    publisher_id: projMap[b.project_id]?.publisher_id || null,
    project_name: projMap[b.project_id]?.name || "" }));
  return { publishers: pubs.data || [], projects: projs.data || [], books: enriched };
}

export async function assignedPublisherIds(profileId) {
  const grants = await listAccess(profileId);
  if (grants.some((g) => g.scope_type === "all")) {
    const { data } = await supabase.from("rel_publishers").select("id");
    return (data || []).map((r) => r.id);
  }
  const pubIds = new Set();
  grants.filter((g) => g.scope_type === "publisher").forEach((g) => pubIds.add(g.scope_id));
  const bookScopeIds = grants.filter((g) => g.scope_type === "book").map((g) => g.scope_id);
  if (bookScopeIds.length) {
    const { data: books } = await supabase.from("rel_books").select("id, project_id").in("id", bookScopeIds);
    const projIds = [...new Set((books || []).map((b) => b.project_id))];
    if (projIds.length) {
      const { data: projs } = await supabase.from("rel_projects").select("id, publisher_id").in("id", projIds);
      (projs || []).forEach((p) => pubIds.add(p.publisher_id));
    }
  }
  return [...pubIds];
}

/* ============ المرحلة 7: مسار حفظ العضو - سجلّ واحد، RLS يفرض الصلاحية ============ */
function bookTreeToPatch(b) {
  return { name: b.name || null, name_fr: b.nameFr || null, lang: b.lang || null, category: b.category || null,
    author_name: b.authorName || null, author_email: b.authorEmail || null, author_phone: b.authorPhone || null,
    trans_name: b.transName || null, trans_nat: b.transNat || null, trans_email: b.transEmail || null, trans_phone: b.transPhone || null,
    fee1: b.fee1 || null, fee2: b.fee2 || null, trans_delivery_date: b.transDeliveryDate || null, trans_received: !!b.transReceived,
    isbn_ar: b.isbnAr || null, isbn_fr: b.isbnFr || null, notes: b.notes || null,
    pub_ar: b.pubAr || null, pub_fr_house: b.pubFrHouse || null, pub_fr_name: b.pubFrName || null, pub_fr_email: b.pubFrEmail || null, print_offer: b.printOffer || null,
    icon: b.icon || null, icon_img: b.iconImg || null, dot_color: b.dotColor || null,
    status: b.status || "active", visibility: b.visibility || "shared", updated_at: new Date().toISOString() };
}
export async function updateBookOnly(book) {
  const { error } = await supabase.from("rel_books").update(bookTreeToPatch(book)).eq("id", book.id);
  return error ? { error: error.message } : { ok: true };
}
export async function saveBookFinance(bookId, data) {
  const orgId = await getOrgId(); if (!orgId) return { error: "لا مؤسّسة نشطة." };
  const { error } = await supabase.from("rel_book_finance")
    .upsert({ book_id: bookId, org_id: orgId, data: data || {}, updated_at: new Date().toISOString() }, { onConflict: "book_id" });
  return error ? { error: error.message } : { ok: true };
}
export async function saveBookDeliveries(bookId, data) {
  const orgId = await getOrgId(); if (!orgId) return { error: "لا مؤسّسة نشطة." };
  const { error } = await supabase.from("rel_book_deliveries")
    .upsert({ book_id: bookId, org_id: orgId, data: data || {}, updated_at: new Date().toISOString() }, { onConflict: "book_id" });
  return error ? { error: error.message } : { ok: true };
}

/* ============ م8: تفويض مدراء المشاريع + سير الاعتماد ============ */

/* إنشاء كتاب من مدير مشروع - يولد معلقًا (القاعدة تُجبر ذلك) + طلب اعتماد */
export async function pmAddBook(projectId, fields) {
  try { const _pr = (typeof window !== "undefined" && window.__tpmsProfile) || {}; if (_pr.role === "publisher" || _pr.role === "أديب") return { error: "هذا الإجراء غير متاح لدورك." }; } catch {}
  const orgId = await getOrgId(); if (!orgId) return { error: "لا مؤسّسة نشطة." };
  const au = await authUserSafe();
  const uid = au?.id; if (!uid) return { error: "لا جلسة." };
  const row = { org_id: orgId, project_id: projectId, name: (fields.name || "").trim() || "بلا اسم",
    approval_status: "pending", created_by: uid, status: "active", visibility: "shared", sort: fields.sort ?? 0 };
  row.id = crypto.randomUUID();
  const { error } = await supabase.from("rel_books").insert(row);
  if (error) return { error: error.message };
  const rq = await supabase.from("approval_requests").insert({ org_id: orgId, kind: "book_add", book_id: row.id, requested_by: uid });
  if (rq.error) return { id: row.id, warn: "الكتاب أُنشئ لكن تعذّر تسجيل الطلب: " + rq.error.message };
  return { id: row.id };
}

/* مسودة تعديل كتاب معتمد - الأصل لا يُمسّ + طلب اعتماد */
export async function pmSubmitEdit(bookId, patch, changedKeys = []) {
  try { const _pr = (typeof window !== "undefined" && window.__tpmsProfile) || {}; if (_pr.role === "publisher" || _pr.role === "أديب") return { error: "هذا الإجراء غير متاح لدورك." }; } catch {}
  const orgId = await getOrgId(); if (!orgId) return { error: "لا مؤسّسة نشطة." };
  const au = await authUserSafe();
  const uid = au?.id; if (!uid) return { error: "لا جلسة." };
  // طلب معلق قائم لنفس الكتاب؟ حدث مسودته (آخر تعديل يفوز) بلا طلب جديد ولا جرس مكرر
  const { data: existing } = await supabase.from("approval_requests")
    .select("id, draft_id").eq("book_id", bookId).eq("requested_by", uid)
    .eq("status", "pending").eq("kind", "book_edit").maybeSingle();
  if (existing && existing.draft_id) {
    let merged = changedKeys;
    try {
      const { data: cd } = await supabase.from("book_edit_drafts").select("changed_keys").eq("id", existing.draft_id).maybeSingle();
      const prevK = (cd && Array.isArray(cd.changed_keys)) ? cd.changed_keys : [];
      merged = Array.from(new Set([...prevK, ...changedKeys]));
    } catch {}
    const up = await supabase.from("book_edit_drafts").update({ data: patch, changed_keys: merged }).eq("id", existing.draft_id);
    if (up.error) return { error: up.error.message };
    return { draftId: existing.draft_id, updated: true };
  }
  const draftId = crypto.randomUUID();
  const { error } = await supabase.from("book_edit_drafts")
    .insert({ id: draftId, org_id: orgId, book_id: bookId, author_id: uid, data: patch, changed_keys: changedKeys });
  if (error) return { error: error.message };
  const rq = await supabase.from("approval_requests")
    .insert({ org_id: orgId, kind: "book_edit", book_id: bookId, draft_id: draftId, requested_by: uid });
  if (rq.error) return { draftId, warn: "المسودة سُجّلت لكن تعذّر الطلب: " + rq.error.message };
  return { draftId };
}

/* طلبات الاعتماد المعلقة (المدير يرى الكل؛ العضو يرى طلباته) */
export async function listApprovalRequests(pendingOnly = true) {
  let q = supabase.from("approval_requests")
    .select("id, kind, book_id, draft_id, requested_by, status, created_at")
    .order("created_at", { ascending: false });
  if (pendingOnly) q = q.eq("status", "pending");
  const { data, error } = await q;
  if (error) throw new Error(error.message);
  return data || [];
}

/* تفاصيل مسودة (لعرض المقارنة قبل الختم) */
export async function getDraft(draftId) {
  const { data, error } = await supabase.from("book_edit_drafts").select("id, book_id, data, status").eq("id", draftId).maybeSingle();
  if (error) throw new Error(error.message);
  return data;
}

/* الختم: اعتماد أو رفض - عبر الدالّة الذرّية (مدير عام فقط) */
export async function resolveApproval(requestId, approve) {
  const { error } = await supabase.rpc("resolve_approval", { p_request: requestId, p_approve: !!approve });
  return error ? { error: error.message } : { ok: true };
}

/* عدّاد الجرس */
export async function pendingApprovalsCount() {
  const { count, error } = await supabase.from("approval_requests")
    .select("id", { count: "exact", head: true }).eq("status", "pending");
  return error ? 0 : (count || 0);
}


/* تغيير دور عضو قائم - المدير العام فقط (RLS تفرضها). لا يمسّ حسابات admin. */
export async function adminSetRole(profileId, role) {
  if (role === "admin" || role === "owner") return "لا يمكن إسناد دور إداري من هذا المسار";
  const { error } = await supabase.from("profiles").update({ role }).eq("id", profileId);
  return error ? (error.message || "تعذر تحديث الدور") : null;
}
